<div class="h-auto">
    <app-reg-form-header></app-reg-form-header>

    <div class="d-flex flex-column flex-md-row p-4 mainContainer main">
        <div class="col-12 col-md-2 leftSidePanel">
            <app-left-side-panel></app-left-side-panel>
        </div>
        <div class="col-12 col-md-8 mx-md-4 mt-4 mt-md-0 formContainer">
            <app-registration-form></app-registration-form>
        </div>
        <div class="w-3 rightSidePanel">
            <!-- <app-profile-progress></app-profile-progress> -->
        </div>
    </div>

    <div class="h-auto mt-auto">
        <app-footer></app-footer>
    </div>
</div>